// src/components/features/Elevation/components/ElevationStep11StaircasePattern.jsx
// Staircase Pattern (Internal/External) — (folder "11.Staircase pattern
// (Internal external) Radio" — "Radio" naam hai, isliye radio /
// single-select UI use kiya gaya hai)

import ElevationRadioStep from "./shared/ElevationRadioStep";
import { STAIRCASE_PATTERN_IMAGES } from "../../../../assets/Elevation/elevationAssets";

// STAIRCASE_PATTERN_IMAGES = [Closed-1, Closed-2, Open-1, Open-2]
// Har type ke 2-2 reference photos hain — Radio (single-select) ke liye
// har type ka pehla (best) photo use kiya hai.
const OPTIONS = [
  { ...STAIRCASE_PATTERN_IMAGES[2], label: "Open Staircase", sub: "Open riser / open-sided staircase design" },
  { ...STAIRCASE_PATTERN_IMAGES[0], label: "Closed Staircase", sub: "Fully enclosed staircase with solid walls" },
];

export default function ElevationStep11StaircasePattern(props) {
  return (
    <ElevationRadioStep
      {...props}
      title="Staircase Pattern"
      subtitle="Choose the internal / external staircase pattern"
      options={OPTIONS}
      fieldKey="elevationStaircasePattern"
    />
  );
}
